import { useState } from 'react';

import { AxiosPublic } from '../utils/axios';

export const useReset = () => {
  const [isFetching, setFetching] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  return {
    error,
    isFetching,
    success,
    submit: async (values: any) => {
      try {
        setError(false);
        setFetching(true);
        await AxiosPublic.post('/users/reset', values);
        setFetching(false);
        setSuccess(true);
      } catch (e) {
        setError(true);
        setSuccess(false);
        setFetching(false);
      }
    },
  };
};
